import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavItem } from '../nav-item';

export interface SidebarNavConfig {
  logo?: string;
  logoRouterLink?: string;
  items?: NavItem[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'vs-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  standalone: false,
})
export class SidebarNavComponent {
  constructor(private route: ActivatedRoute) {}
  private _collapsed = false;

  @HostBinding('class')
  get styles() {
    const padding = this._collapsed ? 'px-2' : 'px-4';
    const width = this._collapsed ? 'w-20' : 'w-80';
    const gap = this._collapsed ? 'gap-4' : 'gap-6';
    return `flex flex-col ${gap} ${width} h-full pt-8 pb-4 ${padding} transition-all duration-200`;
  }
  @HostBinding('class.collapsed') get collapsedClass() {
    return this._collapsed;
  }

  @Input() config: SidebarNavConfig = {};
  openedIndex: number | null = null;

  @Input()
  get collapsed() {
    return this._collapsed;
  }

  set collapsed(value: boolean) {
    this._collapsed = !!value;
    if (this._collapsed) this.openedIndex = null;
  }
}
